import { useMemo } from 'react'
import { ScreenBreakpoints } from '../config/ScreenBreakpoints'
import { useWindowSize } from './useWindowSize'

type NotificationOptions = {
  offset: [number, number]
  placement:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end'
}

export type NotificationOptionTypes =
  | 'SocialSharing'
  | 'FavoritesNote'
  | 'SocialSharingPropertyInformation'

const { breakpointMd, breakpointMl } = ScreenBreakpoints

export const useNotificationOptions = (
  notificationType: NotificationOptionTypes
): NotificationOptions => {
  const { width } = useWindowSize()
  return useMemo(() => {
    switch (notificationType) {
      case 'SocialSharing':
        if (width && width < breakpointMd) {
          return {
            offset: [0, -40],
            placement: 'bottom-start',
          }
        }
        if (width && width < breakpointMl) {
          return {
            offset: [0, -50],
            placement: 'bottom-start',
          }
        }
        return {
          offset: [0, -70],
          placement: 'bottom-start',
        }
      case 'FavoritesNote':
        if (width && width < breakpointMd) {
          return {
            offset: [0, -135],
            placement: 'bottom-start',
          }
        }
        if (width && width < breakpointMl) {
          return {
            offset: [-35, -140],
            placement: 'bottom-start',
          }
        }
        return {
          offset: [-32, -142],
          placement: 'bottom-start',
        }
      case 'SocialSharingPropertyInformation':
        if (width && width < breakpointMd) {
          return {
            offset: [0, 0],
            placement: 'bottom-start',
          }
        }
        if (width && width < breakpointMl) {
          return {
            offset: [100, 10],
            placement: 'left',
          }
        }
        return {
          offset: [100, 10],
          placement: 'left',
        }
    }
  }, [width, notificationType])
}
